<template lang="html">
	<div class="omapi-wizard-exit">
		<a :class="linkClass" :href="href" @click.prevent="exit('previous')">
			<slot>Close and Exit Wizard without Saving</slot>
		</a>
	</div>
</template>
<script lang="js">
import { mapActions } from 'vuex'
export default {
	props : {
		linkClass : String,
	},
	computed : {
		href () {
			let route = this.$router.getPreviousRoute()
			if (!route.name) {
				route = this.$router.getRouteForSlug('dashboard')
			}
			return route.fullPath || route.path
		},
	},
	methods : {
		...mapActions('wizard', [ 'exit' ]),
	},
}
</script>
